$(document).ready(function () {
  const target = document.querySelector(".ess-nm-numbers-section");
  const gifOne = document.querySelector(".section-two__img");
  const gifTwo = document.querySelector(".section-three__img");

  const sectionOne = document.querySelector(".section--1");
  const sectionTwo = document.querySelector(".section--2");
  const sectionThree = document.querySelector(".section--3");

  const options = {
    rootMargin: "0px 0px -80% 0px",
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(target);

        // fade in section 1
        sectionOne.classList.add("show");
        // fade in section 2
        setTimeout(() => {
          sectionTwo.classList.add("show");
        }, 1800);
        // play section 2 gif
        setTimeout(() => {
          gifOne.src = "/pages/new-mexico/assets/img/ASTHO_NM_gif1.gif";
        }, 2100);
        // fade in section 3
        setTimeout(() => {
          sectionThree.classList.add("show");
        }, 8600);
        // play section3 gif
        setTimeout(() => {
          gifTwo.src = "/pages/new-mexico/assets/img/ASTHO_NM_gif2.gif";
        }, 8900);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  observer.observe(target);
});
